import AppContent from '@components/App/appContent';
import PageContentWrapper from '@components/App/PageComponents/pageContentWrapper';
import { withStyles, Grid, Paper } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { push } from 'react-router-redux';
import { withTranslation } from 'react-i18next';
import { initSubscriptionModal, openSubscriptionModal } from '../../../actions/upgradeSubscriptionActions';
import { AdminUpgradeButton } from '../../components/Common/Subscription/AdminUpgradeButton/AdminUpgradeButton';


const styles = theme => ({
    paper: {
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    container: {
        "alignItems": "center",
        "display": "flex",
        "flexDirection": "column",
        position: 'relative',
    },
    image: {
        "color": "#4285f4",
        "height": "48px",
        "width": "48px",
        paddingBottom: 5
    },
    adminButton: {
        "alignItems": "center",
        "borderRadius": "5px",
        "color": "inherit",
        "display": "flex",
        "flexDirection": "column",
        "padding": "16px",
        "&:hover": {
            background: "#efefef",
            cursor: 'pointer'
        },
        width: 162,
    },

    title: { "fontFamily": "Rubik", "fontWeight": "400", "fontSize": "16px", "color": "#21212D", "letterSpacing": "0.15px", "lineHeight": "24px", "textAlign": "center" },
    subtitle: { "fontFamily": "Rubik", "fontSize": "14px", "color": "#979AAA", "letterSpacing": "0.25px", "textAlign": "center", "lineHeight": "20px" },
    adminUpgradeButton: {
        position: 'absolute',
        width: 'fit-content',
        right: 3,
        top: 3
    }
})


const AdminButtonView = (props) => {
    const { classes, title, subtitle, image, onClick, withUpgrade, t } = props;

    return <Grid item xs={4} sm={2} onClick={!withUpgrade ? onClick : () => {}}>
        <div data-intrcm-id="AdminHome_sza88jqx" style={{pointerEvents: withUpgrade ? 'none' : 'auto'}} className={classes.container}>
            {withUpgrade && 
                <AdminUpgradeButton
                    onClick={withUpgrade ? onClick : () => {}} 
                    containerStyle={classes.adminUpgradeButton}
                    translations={{upgrade: t("Upgrade")}}
                />
            }
            <div data-intrcm-id="AdminHome_7zlyy7o4" className={classes.adminButton}>
                <img src={image} className={classes.image} />
                <div data-intrcm-id="AdminHome_7kegxhdr" className={classes.title}>{title}</div>
                <div data-intrcm-id="AdminHome_nnsetae3" className={classes.subtitle}>{subtitle}</div>
            </div>
        </div>
    </Grid>
}
AdminButtonView.defaultProps = {
    withUpgrade: false
}
const AdminButton = compose(
    withTranslation('admin'),
)(AdminButtonView);


class AdminHome extends React.Component {
    constructor(props, context) {
        super(props, context);


    }
    openSubscriptionDialog = (reason) => {
        const { dispatch } = this.props;
        dispatch(initSubscriptionModal({reason, mode: 'existed'}))
        dispatch(openSubscriptionModal())
    }

    canUseTimeTracking = () => {
        const { subscription } = this.props;
        if([0, 1].includes(subscription.subscriptionType)) return false
        return true
    }
    canUseContentManagement = () => {
        const { subscription } = this.props;
        if([0, 1].includes(subscription.subscriptionType)) return false
        return true
    }

    render() {
        const { classes, dispatch, t } = this.props;
        const allowContentManagement = this.canUseContentManagement()
        const allowTimeTracking = this.canUseTimeTracking()

        return <AppContent >
            <Grid
                container
                direction="row"
                alignItems="flex-start"
                style={{ maxWidth: 1600, margin: 'auto' }}
            >
                <AdminButton classes={classes}
                    image={'/resources/admin/dashboard-48px.svg'}
                    title={t("Dashboard")} subtitle={t('Basic system usage')} onClick={() => { dispatch(push("admin/dashboard")) }} />
                <AdminButton classes={classes} image={'/resources/admin/people_alt-48px.svg'}
                    title={t("Manage Users")} subtitle={t('Edit, Assign permissions add & remove users')} onClick={() => { dispatch(push("/admin/users")) }} />
                <AdminButton classes={classes} image={'/resources/admin/apps-48px.svg'}
                    title={t("Impersonalization")} subtitle={t('Map between users to professional apps')} onClick={() => { dispatch(push('/admin/sources')) }} />
                <AdminButton classes={classes} image={'/resources/admin/ballot-48px.svg'} title={t("Data types")} subtitle={t('Manage the types of data available in the platform')} onClick={() => { dispatch(push('/admin/custominputmappings')) }} />
                <AdminButton classes={classes} image={'/resources/admin/verified_user-48px.svg'} title={t("Classifications")} subtitle={t('Manage classification of data & users')} onClick={() => { dispatch(push('/admin/classifications')) }} />
                <AdminButton classes={classes} image={'/resources/admin/class-48px.svg'} title={t("Certifications")} subtitle={t('Manage, assign, remove & add certifications to users')} onClick={() => { dispatch(push('/admin/certifications')) }} />
                <AdminButton classes={classes} image={'/resources/admin/settings_applications-48px.svg'} title={t("Organization settings")} subtitle={t('General settings of the organizational platform')} onClick={() => { dispatch(push('/admin/organizationsettings')) }} />
                <AdminButton classes={classes} image={'/resources/admin/unarchive-48px.svg'} title={t("Archive")} subtitle={t('Browse the archive of unused data')} onClick={() => { dispatch(push('/admin/archive')) }} />
                <AdminButton classes={classes} image={'/resources/admin/cloud_done-48px.svg'} title={t("Logs")} subtitle={t('Browse the activity logs of the users & data')} onClick={() => { dispatch(push('/admin/logs')) }} />
                <AdminButton classes={classes} image={'/resources/admin/score-48px.svg'} title={t("Scoreboard")} subtitle={t('Manage the pointing system to encourage users to be more active')} onClick={() => { dispatch(push('/admin/scoreBoardSettings')) }} />
                <AdminButton classes={classes} image={'/resources/admin/label-48px.svg'} title={t("Content management")} subtitle={t('Manage the tagging system of the platform')} withUpgrade={!allowContentManagement} onClick={() => { allowContentManagement ? dispatch(push('/admin/topics_and_usertags')) : this.openSubscriptionDialog("contentManagement") }} />
                <AdminButton classes={classes} image={'/resources/admin/payment-48px.svg'} title={t("Billing")} subtitle={t('Manage your subscription, payment methods and pricing plans')} onClick={() => { dispatch(push('/admin/billing')) }} />
                <AdminButton classes={classes} image={'/resources/admin/time.svg'} title={t("Time tracking")} subtitle={t('Track time on tasks, view reports')} withUpgrade={!allowTimeTracking} onClick={() => { allowTimeTracking ? dispatch(push('/admin/timetracking')) : this.openSubscriptionDialog("timeTracking") }} />
                {this.props.userData.profileData.org.orgUid === 'ashtrom' ? <AdminButton classes={classes} image={'/resources/admin/premium_report.svg'} title={t("Premium Reports")} subtitle={t('Premium reports')} onClick={() => { dispatch(push('/admin/premium')) }} /> : null}
                {this.props.userData.profileData.org.orgUid === 'tuqqi' ? <AdminButton classes={classes} image={'/resources/admin/premium_report.svg'} title={t("Premium Reports")} subtitle={t('Premium reports')} onClick={() => { dispatch(push('/admin/tuqqi')) }} /> : null}
                {/* <AdminButton classes={classes} image={'/resources/admin/bubble_chart-48px.svg'} title={"Knowledge Graph"}
                    subtitle={'View data & users from an organizational perspective'} onClick={() => { dispatch(push('/admin/graph')) }} /> */}
            </Grid>
        </AppContent >;
    }
}
const mapStateToProps = (state) => ({
    ...state.services,
    templates: state.globalData.templates,
    token: state.userData.idToken,
    userData: state.userData,
    subscription: state.globalData.currentSubscription,

})


const mapDispatchToProps = dispatch => {
    return {
        dispatch: dispatch
    }
}

export default compose(withStyles(styles),
    withTranslation('admin'),
    connect(
        mapStateToProps,
        mapDispatchToProps
    ))(AdminHome);